/**
 * Separa croquis de fotos en las imágenes de una Order, para el informe.
 *
 * El croquis se identifica por el nombre: `directoryNaming.CANVAS` genera
 * `canvas-action` / `canvas-accident` al subir el dibujo (ver
 * `EditAccident/DamagesAndVehicles/Action/saveData.ts`). Las imágenes sin URL
 * (subida diferida offline aún sin resolver) se descartan: no se pueden pintar.
 *
 * Módulo PURO (sin Apollo ni i18n) → testeable sin navegador.
 */

export type ReportImage = {
  url: string;
  name: string;
  /**
   * Pie de ubicación: «C-25 · PK 150 + 300 · …» y «lat, lng · hora · ±m».
   * Solo con el flag y si la foto tiene GPS (spec fotos geolocalizadas § 19).
   */
  location?: string[];
};

/**
 * Cuántas fotos pinta `ImageGrid` por registro. Vive aquí, en el módulo puro,
 * porque el histórico lo usa para buscar la ubicación solo de esas, y el
 * modal no debe importar react-pdf (va en un trozo aparte).
 */
export const MAX_GRID_IMAGES = 6;

/** El croquis se reconoce por el nombre (`canvas-action` / `canvas-accident`). */
export const isSketchName = (name: string | null | undefined): boolean =>
  name?.toLowerCase().includes('canvas') ?? false;

const isSketch = (img: ReportImage): boolean => isSketchName(img.name);

export function splitSketchImages(images: ReportImage[] = []): {
  sketches: ReportImage[];
  photos: ReportImage[];
} {
  const withUrl = images.filter((img) => Boolean(img.url));
  return {
    sketches: withUrl.filter(isSketch),
    photos: withUrl.filter((img) => !isSketch(img)),
  };
}
